import { useEffect, useState } from "react";
import { Title } from "./base/Title";
import {
  BaseQuestion,
  YesOrNoQuestion,
  InputNumberQuestion,
  InputQuestion,
  ScoredAnswerQuestion,
  ScoredAnswerQuestion1,
  ScoredAnswerQuestion2,
  CheckboxAnswerQuestion,
  RadioGroupAnswerQuestion,
  TableQuestion
} from "./base/BaseQuestion";
import { Alert, Steps, Modal, Form, Button, Dropdown, Menu, Drawer } from "antd";



import { StepButton } from "./step-button";

export const Introduce1 = ({
  title,
  handleSubmit,
  handleFail,
  currentStep,
  flowStepsLenght,
}) => {
  const majorIndex = 0;
  const [nextStep, setNextStep] = useState(false);
  const [isUsedMRT, setUsedMRT] = useState(false);
  const [isUsedMRT1, setUsedMRT1] = useState();

  return (
    <div>

      <div className="text-center my-6">
        <p className="text-4xl font-semibold text-green-600">        HƯỚNG DẪN
        </p>
      </div>


      <div className="text-left" style={{ textAlign: "justify" }}>
        <p>
          Khi Anh/Chị đồng ý tham gia khảo sát, vui lòng lưu ý những thông tin sau:
        </p>
        <ul class="custom-list">
          <li><b>Bảo mật</b>: Tất cả thông tin Anh/Chị cung cấp sẽ được giữ bí mật tuyệt đối và chỉ sử dụng cho mục đích nghiên cứu. Dữ liệu cá nhân của Anh/Chị sẽ không được tiết lộ cho bất kỳ bên thứ ba nào.</li>
          <li><b>Ẩn danh</b>: Câu trả lời của Anh/Chị sẽ hoàn toàn ẩn danh.</li>
          <li><b>Thời gian thực hiện</b>: Hoàn thành khảo sát này dự kiến mất <b>khoảng 15–25 phút.</b></li>
        </ul>
        <p>
          Phiếu khảo sát gồm 5 phần chính, cụ thể như sau:
        </p>
        <ul class="custom-list">
          <li><b>Phần 1</b>: Trải nghiệm metro của người tham gia khảo sát;</li>
          <li><b>Phần 2</b>: Khảo sát hành vi tham gia giao thông;</li>
          <li><b>Phần 3</b>: Thái độ và nhận thức;</li>
          <li><b>Phần 4</b>: Lựa chọn loại hình di chuyển tích hợp mới (MaaS);</li>
          <li><b>Phần 5</b>: Thông tin chung của người tham gia khảo sát.</li>
        </ul>



        <p>Các câu hỏi sẽ được trình bày <b>dưới dạng in đậm</b>. Câu trả lời có thể là dạng <b>trắc nghiệm hoặc thang đo</b>, yêu cầu người trả lời lựa chọn phương án <b>phù hợp nhất</b>. Vui lòng <b>trả lời từng câu hỏi theo thứ tự</b> trong bảng khảo sát.</p>

        <p>
          Hãy <b>đọc kỹ</b> từng câu hỏi và chọn <b>phương án phản ánh đúng nhất</b> ý kiến hoặc tình huống của Anh/Chị.
        </p>

        <p>
          Trước khi tham gia khảo sát, chúng tôi muốn nhấn mạnh lại rằng <b>mục tiêu của khảo sát này nhằm phân tích rõ hơn đặc điểm tâm lý và hành vi di chuyển của người dân Hà Nội đối với loại hình giao thông mới của thành phố – hệ thống metro</b>. Sự đóng góp của Anh/Chị sẽ góp phần quan trọng trong việc <b>cải thiện hệ thống giao thông hiện tại và nâng cao trải nghiệm sử dụng hệ thống metro</b>.
        </p>
        <p>
          Sau khi đợt khảo sát này kết thúc, <b>100 người đã hoàn thành phiếu hỏi</b> sẽ được lựa chọn ngẫu nhiên nhận được <b>phần quà cảm ơn</b> từ chúng tôi!
        </p>
        <p>
          Với những hướng dẫn trên, Anh/Chị có đồng ý tham gia khảo sát này <b>một cách tự nguyện và hoàn toàn miễn phí</b> không?
        </p>
        <Form
          onFinish={(value) => handleSubmit(value, nextStep)}
          onFinishFailed={handleFail}
        >
          <YesOrNoQuestion
            majorIndex={undefined}
            mirrorIndex={undefined}
            question=""
            rawQuestion="Với những hướng dẫn trên, bạn có đồng ý tham gia khảo sát này một cách tự nguyện và hoàn toàn miễn phí không?"
            yesAnswer="Có"
            noAnswer="Không"
            onChange={(value) => {
              console.log("Giá trị đã chọn:", value);
              setUsedMRT(value === "Có");
              setUsedMRT1(value === "Không");

            }}
          />
          {isUsedMRT && (
            <StepButton
              onStepChange={setNextStep}
              currentStep={currentStep}
              flowStepsLenght={flowStepsLenght}
            />

          )}
          {isUsedMRT1 && (
            <div className="fixed top-[40vh] left-[30vw] w-[40vw] z-50">
              <Alert
                description="Cảm ơn anh/chị đã tham gia khảo sát"
                type="success"
                showIcon
                closable
                onClose={() => {
                  window.location.reload();
                }}
              />
            </div>

          )}


        </Form>
        <br />
        <br />
        <br />
      </div>

    </div>
  );
};
